/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-top:15px;margin-bottom:15px}.nomargin[_ngcontent-%COMP%]{margin:0}.bottomborder[_ngcontent-%COMP%]{border-bottom:1px solid}.topmargin[_ngcontent-%COMP%]{margin-top:15px}.bottommargin[_ngcontent-%COMP%]{margin-bottom:15px}.toppadding[_ngcontent-%COMP%]{padding-top:15px}.bottompadding[_ngcontent-%COMP%]{padding-bottom:15px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.css.shim.ngstyle.js.pre-build-optimizer.js